export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TIMEOUT = 15000;
export const API_VERSION = '/api/v1/bmr/';